<div
    #tooltip="ngbTooltip"
    class="color-trigger"
    [ngStyle]="{'background-color': color}"
    [ngbTooltip]="colorPicker"
    triggers="click"
    [placement]="placement"
    tooltipClass="color-picker"
    (shown)="onColorPickerOpened()"
    (hidden)="onColorPickerClosed()"
    [autoClose]="'outside'">
</div>

<ng-template #colorPicker>
  <div class="color-picker-wrapper">
    <span class="close-icon" (click)="tooltip.close()">x</span>
    <color-sketch [presetColors]="presetColors" [color]="color" [disableAlpha]="disableAlpha" (onChangeComplete)="changeComplete($event)"></color-sketch>
  </div>
</ng-template>
